import '../MainDashboard.scss';

const DashboardTitleType = ({title}) => {

    return (

        <div className="main-green-title">
            <p>{title}</p>
        </div>
    );
};

export default DashboardTitleType;